import { Button } from "@sellar-io/components";
import { useForm } from "react-hook-form";
import { v4 } from "uuid";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { usePriceTierOrderRuleCreate } from "../../../../hooks/api/v2/priceTierOrderRule/usePriceTierOrderRuleCreate";
import { OrderRuleForm } from "./OrderRuleForm";
import { PriceTierOrderRuleFormValues } from "./OrderRuleForm.shared";
import { useOrderRulesCreate } from "../../../../hooks/api/v2/orderRules/useOrderRulesCreate";

const formId = v4();

export const OrderRuleDialogCreate = ({
  orderRulesId,
  active,
  onDismiss,
  deliveryMethod,
  minimumOrderPrice = 0,
}: {
  orderRulesId: number | null;
  active: boolean;
  onDismiss: () => void;
  deliveryMethod?: {
    id: number;
    name: string | null;
  };
  minimumOrderPrice?: number;
}) => {
  const form = useForm<PriceTierOrderRuleFormValues>({
    shouldUseNativeValidation: true,
  });

  const priceTierOrderRuleCreateMutation = usePriceTierOrderRuleCreate();
  const orderRulesCreateMutation = useOrderRulesCreate();

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={`Add order rule`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        <OrderRuleForm
          key={formId}
          form={form}
          formId={formId}
          onSave={(data) => {
            if (!orderRulesId && deliveryMethod) {
              orderRulesCreateMutation.mutate(
                {
                  name: `${deliveryMethod.name ?? `Delivery Method ${deliveryMethod.id}`} - order rules`,
                  minimumOrderPrice,
                  FulfillmentTypeId: deliveryMethod.id,
                },
                {
                  onSuccess: (createdOrderRules) => {
                    priceTierOrderRuleCreateMutation.mutate(
                      { ...data, OrderRulesId: createdOrderRules.id },
                      {
                        onSuccess: () => {
                          onDismiss();
                        },
                      },
                    );
                  },
                },
              );
            } else {
              priceTierOrderRuleCreateMutation.mutate(
                { ...data, OrderRulesId: orderRulesId },
                {
                  onSuccess: () => {
                    onDismiss();
                  },
                },
              );
            }
          }}
        />
        {priceTierOrderRuleCreateMutation.isError ? (
          <Alert
            message={
              apiV2AssertError(priceTierOrderRuleCreateMutation.error)?.response
                ?.data.message ?? "Unknown error"
            }
          ></Alert>
        ) : null}
      </DialogContent>
      <DialogCTA>
        <Button
          loading={priceTierOrderRuleCreateMutation.isPending}
          form={formId}
          type={"submit"}
        >
          Add
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
